import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '@/components/ui';
import { useWorkerProfile } from '@/api/worker';
import { useAuthStore } from '@/stores/useAuthStore';
import { ROUTES } from '@/constants/routes';
import styles from './WorkerGuard.module.css';

export function WorkerGuard() {
    const { data: profile, isLoading } = useWorkerProfile();
    const getUser = useAuthStore((s) => s.getUser);
    const user = getUser();

    if (user?.is_staff) {
        return <Outlet />;
    }

    if (isLoading) {
        return (
            <div className={styles.loading}>
                <Spinner size="lg" />
            </div>
        );
    }

    if (!profile || profile.status !== 'approved') {
        return <Navigate to={ROUTES.onboarding} replace />;
    }

    return <Outlet />;
}
